import { inject, injectable } from '../shared/inversify'
import { psHttp$, RequestChannel } from '@patsnap/common-ps-http';
import _ from 'lodash'

export const PsHttp$ = Symbol.for('psHttp$')

export type PsHttp$ = typeof psHttp$;

export const PsHttpChannel = Symbol.for('PsHttpChannel');

export interface PsHttpChannel {
    getChannel<T, C>(symbolId: symbol): RequestChannel<T, C>
}

/**
 * PsHttpChannelImpl is an implementation of the PsHttpChannel interface.
 * It provides a mapping between symbol IDs and request channels.
 */
@injectable()
export class PsHttpChannelImpl implements PsHttpChannel {
    protected readonly channelMap: Map<symbol, RequestChannel<any, any>> = new Map();

    constructor(
        @inject(PsHttp$)
        protected readonly httpChannelClient: PsHttp$,
    ) {}

    /**
     * Retrieves the request channel associated with the specified symbol ID.
     * If the channel does not exist, a new channel is created and added to the channel map.
     * @param symbolId - The symbol ID used to identify the request channel.
     * @returns The request channel associated with the symbol ID.
     */
    getChannel<T, C>(symbolId: symbol): RequestChannel<T, C> {
        let channel = this.channelMap.get(symbolId);
        if(channel) {
            return channel;
        }

        channel = new RequestChannel(this.httpChannelClient);
        this.channelMap.set(symbolId, channel)

        return channel;
    }
}
